import React from 'react'
import { useExercise } from '../ExerciseProvider.js'
import { Textarea } from '../../../lib/ui/textarea.js'
import { ClearSelectionsButton } from '~/components/shared/Buttons.js'
import { useTranslation } from '~/hooks/useTranslation.js'

const Questions = ({ questions, section }) => {
  const { handleChange, handleDivClick, getResponse, exerciseIndex } =
    useExercise()
  const { t } = useTranslation('design_thinking')

  const handleClearSelections = () => {
    questions.forEach((question) => {
      if (question.type === 'checkbox') {
        handleChange(exerciseIndex, question.slug, {
          target: { checked: false },
        })
      }
    })
  }

  return (
    <Wrapper section={section}>
      <div className="questions">
        {questions.map((question, index) => (
          <div key={index} className="mb-6 font-roboto text-base font-medium">
            {question.type === 'checkbox' && (
              <div
                className="flex items-center rounded-[8px] border border-[#D3D3D3] bg-[#F7FAFC] p-3"
                onClick={() => handleDivClick(exerciseIndex, question.slug)}
              >
                <input
                  type="checkbox"
                  className="!mb-1 !mr-2 !mt-0 h-4 w-4 rounded border-gray-300 text-blue-600"
                  onChange={(e) =>
                    handleChange(exerciseIndex, question.slug, e)
                  }
                  checked={getResponse(exerciseIndex, question.slug) || false}
                  onClick={(e) => e.stopPropagation()}
                />
                <label className="font-roboto-light !mb-1 text-sm font-medium">
                  {question.question}
                </label>
              </div>
            )}
            {question.type === 'text' && (
              <div className="flex flex-col">
                <label className="!mb-1">{question.question}</label>
                <Textarea
                  className="min-h-[125px] w-full rounded-[20px]"
                  onChange={(e) =>
                    handleChange(exerciseIndex, question.slug, e)
                  }
                  value={getResponse(exerciseIndex, question.slug) || ''}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      {section === 2 && (
        <ClearSelectionsButton
          onClick={handleClearSelections}
          className={'self-end'}
        >
          {t('clear_selections')}
        </ClearSelectionsButton>
      )}
    </Wrapper>
  )
}

export default Questions

const Wrapper = ({ section, children }) => {
  if (section === 2) {
    return <div className="flex flex-col gap-2">{children}</div>
  }
  return children
}
